module.exports = __webpack_public_path__ + "img/wire-4.909a6e35.jpg";